__turbopack_context__.v({
  "showMoreTextContainer": "Template-module-scss-module__5zr9Yq__showMoreTextContainer",
});
